<template>
  <v-dialog
    v-model="$store.state.upgradeGain"
    @update:modelValue="clear"
  >
    <v-card
      class="pa-6"
    >
      <div
        class="d-flex align-center font-weight-bold"
      >
        <h2>{{ $t('review_compare_results') }}</h2>
        <v-spacer />
        <v-btn
          icon
          size="x-small"
          elevation="0"
          @click="closeDialog"
        >
          <img :src="require('@/assets/close-circle.svg')" alt="close">
        </v-btn>
      </div>

      <div
        class="text-N100 mt-2"
      >
        {{ $t('upgrade_gain_full_access') }}
      </div>

      <v-row class="mt-8 mb-4">
        <v-col
          cols="12"
          lg="3"
          md="6"
          v-for="plan in plans.sort((a, b) => a.id > b.id ? 1 : -1)"
          :key="plan.id"
        >
          <v-card elevation="8" class="pa-4 text-white h-100 d-flex flex-column">
            <h2 class="font-weight-bold">
              {{ plan.name }}
            </h2>

            <h4 class="text-N100 mt-4">
              {{ plan.description }}
            </h4>

            <h3 class="text-N600 text-center mt-4">
              <strong class="font-weight-bold mt-5">{{ plan.amount }}</strong> {{ plan.currency }} / {{ plan.days }} {{ $t('days') }}
            </h3>

            <v-card-item>
              <div
                class="d-flex align-center my-4"
                v-for="option, index in plan.options"
                :key="index"
              >
                <div class="mr-4">
                  <img v-if="plan.id === 1 && index === 1" :src="require('@/assets/uncheck.svg')">
                  <img v-else :src="require('@/assets/check.svg')">
                </div>
                <div class="text-N600">
                  {{ option }}
                </div>
              </div>
            </v-card-item>

            <div class="mt-auto w-100">
              <v-btn
                class="w-100"
                size="large"
                color="primary"
                :loading="plan.loading"
                :disabled="plan.is_basic || plan.loading"
                @click="upgrade_plan(plan)"
              >
                <h5 class="font-weight-bold text-capitalize text-white">{{ $t('upgrade_to') }} {{ plan.name }}</h5>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import jwtDecode from "jwt-decode";

export default {
  name: 'UpgradeGain',
  computed: {
    is_factory() {
      let user_info = jwtDecode(localStorage.getItem("access")).user_info
      return user_info.is_admin || user_info.is_verify_operator
    }
  },
  data: () => ({
    plans: []
  }),
  mounted() {
    if (this.is_factory) {
      api.plans().then(res => {
        this.plans = res.data
      })
    }
  },
  methods: {
    upgrade_plan(plan) {
      plan.loading = true
      api.upgrade_plan(plan.id).then(res => {
        plan.loading = false
      }).catch(() => plan.loading = false)
    },
    clear() {
      this.name = ''
      this.registration_code = ''
    },
    closeDialog() {
      this.clear()
      this.$store.state.upgradeGain = false
    },
  }
}
</script>
